<template>
    <div class="verified-input">
        <VerifiedLable
            :id="id"
            :title="title"
            :tagnewid="tagnewid"
            :required="required"
            :disableMLtitle="disableMLtitle"
            :tooltipLabel="tooltipLabel"
            :tooltipPosition="tooltipPosition"
            :tooltipType="tooltipType"
            :tooltipSize="tooltipSize"
            :tooltipMultilined="tooltipMultilined"
        />
        <s-select
            :id="id"
            ref="select"
            :class="{ invalid: focusedOut && invalid && innerInvalidWhenDisabled }"
            :value="
                value && value.label != undefined
                    ? mlLabelsTitle
                        ? $t(value.label)
                        : value.label
                    : value
            "
            :options="options"
            :pageOptions="pageOptions"
            :totalResults="totalResults"
            :label="label"
            :paginate="paginate"
            :disabled="disabled"
            :searchable="searchable"
            :clearable="clearable"
            :close-on-select="closeOnSelect"
            :placeholder="
                disableMLplaceholder
                    ? placeholder
                    : getT(placeholder, '')
            "
            :selectHeight="height"
            :dropdownMaxHeight="dropdownHeight"
            :useML="mlLabels"
            :dropup="dropup"
            :loading="loading"
            :tooltip="tooltip"
            :no-results-message="emptyMessage"
            :multiple="multiple"
            :displayFlex="displayFlex"
            :extended="extended"
            :compareId="compareId"
            @observer="$emit('observer', $event)"
            @search="$emit('search', $event)"
            @input="inputFunction($event)"
            @focus="focus"
            @blur="blur"
        >
            <template #selected="{ option }">
                <slot name="selected" v-bind:option="value">
                    <span
                        id="icone-selected"
                        v-if="value != null && value.icone && showIcon"
                        class="icon mr-2 ml-1"
                        :style="{ color: value.cor ? value.cor : '#333' }"
                    >
                        <i class="fa-lg" :class="value.icone.toLowerCase()" ref="vssIcon" />
                    </span>
                    <span class="icon mr-2 ml-1" v-show="!showIcon">
                        <i class="fas fa-spinner fa-pulse" />
                    </span>
                    <span
                        class="option-label"
                        v-if="mlLabels"
                        :title="option ? $t(getLabel(option)) : ''"
                    >
                        {{ option ? $t(getLabel(option)) : '' }}
                    </span>
                    <span class="option-label" v-else :title="getLabel(option)">
                        {{ getLabel(option) }}
                    </span>
                </slot>
            </template>
            <template #option="{ option }">
                <slot name="option" v-bind:option="option">
                    <span
                        v-if="option.icone && iconPosition == 'left'"
                        class="icon"
                        :style="{ color: option.cor ? option.cor : '#333' }"
                    >
                        <i :class="option.icone.toLowerCase()" />
                    </span>
                    <span
                        class="option-label"
                        v-if="mlLabels"
                        :title="option ? $t(getLabel(option)) : ''"
                    >
                        {{ option ? $t(getLabel(option)) : '' }}
                    </span>
                    <span class="option-label" v-else :title="getLabel(option)">
                        {{ getLabel(option) }}
                    </span>
                    <span
                        v-if="option.icone && iconPosition == 'right'"
                        class="icon"
                        :style="{ color: option.cor ? option.cor : '#333' }"
                    >
                        <i :class="option.icone.toLowerCase()" />
                    </span>
                </slot>
                <slot v-if="possuiImagem" name="option" v-bind:option="option">
                    <span class="option-label">
                        <div class="div-imagem" :style="'height:' + tamImagem + 'px;'">
                            <img v-if="option.imagem" :src="option.imagem" alt="" />
                            <svg v-else :style="'width:' + tamImagem + 'px'">
                                <use
                                    :xlink:href="
                                        require('@/assets/img/icons/no-image.svg') + '#layer'
                                    "
                                ></use>
                            </svg>
                        </div>
                    </span>
                </slot>
            </template>
            <template #multiple-selected="{ selected }" v-if="multiple">
                <slot name="multiple-selected" v-bind:selected="selected" v-if="multiple">
                    {{ multipleLabel ? multipleLabel : $t('selecionado') }} ({{
                        selected && selected.length ? selected.length : 0
                    }})
                </slot>
            </template>
        </s-select>

        <span
            class="validation"
            v-text="getT(msg, '')"
            v-if="focusedOut && invalid && innerInvalidWhenDisabled"
        />
        <div class="clearfix" v-else-if="!noClearfix" />
    </div>
</template>

<script>
// component vss-select

import VerifiedLable from '@/components/shared/VerifiedLable.vue';

export default {
    components: {
        VerifiedLable,
    },
    props: {
        value: {
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        invalidWhenDisabled: {
            type: Boolean,
            default: false,
        },
        options: {
            type: Array,
            default: () => [],
        },
        paginate: {
            type: Boolean,
            default: false,
        },
        pageOptions: {
            type: Array,
            default: () => [],
        },
        totalResults: {
            type: Number,
            default: 0,
        },
        id: {
            default: new Date().getTime(),
        },
        placeholder: {
            default: '',
            type: String,
        },
        title: {
            default: '',
            type: String,
        },
        label: {
            default: 'label',
            type: String,
        },
        msg: {
            default: 'msg-campo-obrigatorio',
            type: String,
        },
        invalid: {
            default: false,
            type: Boolean,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: false,
        },
        closeOnSelect: {
            type: Boolean,
            default: true,
        },
        mlLabelsTitle: {
            type: Boolean,
            default: false,
        },
        mlLabels: {
            type: Boolean,
            default: false,
        },
        disableMLplaceholder: {
            type: Boolean,
            default: false,
        },
        // campo usado para traduzir itens especificos da lista de itens.
        // essa variável deve receber o nome do campo usado para definir
        // se deve ou não ser traduzido.
        //
        // Ex.: [{value: 1, label: todos, traduzir: true},
        //      {value: 2, label: Sovis sistemas, traduzir: false}]
        // :mlLabelsField: "'traduzir'"
        //
        // **** somente ser usado sem mlLabels
        mlLabelsField: {
            type: String,
            default: '',
        },
        searchable: {
            type: Boolean,
            default: false,
        },
        tooltip: {
            type: Boolean,
            default: false,
        },
        height: {
            type: Number,
            default: 36,
        },
        dropdownHeight: {
            type: Number,
            default: 200,
        },
        dropup: {
            type: Boolean,
            default: false,
        },
        emptyMessage: {
            type: String,
            default: null,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        multipleLabel: {
            type: String,
            default: null,
        },
        noClearfix: {
            type: Boolean,
            default: false,
        },
        displayFlex: {
            type: Boolean,
            default: true,
        },
        disableMLtitle: {
            type: Boolean,
            default: false,
        },
        // Id do tagnew referente ao .env na raiz do sistema
        tagnewid: undefined,
        // O título fica com a cor primária da empresa e com um asterisco após o título
        required: {
            type: Boolean,
            default: false,
        },
        /* Caso tenha uma informação adicional sobre o campo */
        tooltipLabel: {
            type: String,
            default: null,
        },
        tooltipPosition: {
            type: String,
            default: 'is-right',
        },
        tooltipType: {
            type: String,
            default: 'is-dark',
        },
        tooltipMultilined: {
            type: Boolean,
            default: true,
        },
        tooltipSize: {
            type: String,
            default: 'is-large',
        },
        onBlur: {
            default: true,
            type: Boolean,
        },
        onBlurFunction: {
            default: () => {},
            type: Function,
        },
        iconPosition: {
            type: String,
            default: 'right',
        },
        extended: {
            type: Boolean,
            default: false,
        },
        compareId: {
            type: Boolean,
            default: false,
        },
        possuiImagem: {
            type: Boolean,
            default: false,
        },
        tamImagem: {
            type: Number,
            default: 42,
        },
    },
    data() {
        return {
            focusedOut: false,
            showIcon: true,
            innerInvalidWhenDisabled: false,
            innerValue: null,
            oldValue: null,
        };
    },
    created() {
        this.innerInvalidWhenDisabled =
            !this.disabled || (this.invalidWhenDisabled && this.disabled);
    },
    watch: {
        value: {
            deep: true,
            handler: function () {
                if (this.value != null && this.value.icone) {
                    this.showIcon = false;
                    if (this.$refs.vssIcon) this.$refs.vssIcon.innerHTML = '';
                    setTimeout(() => {
                        this.showIcon = true;
                    }, 400);
                }
                if (!this.multiple) {
                    // envia um aleta para o pai avisando da mudança de valores
                    // console.log('watch', this.title, this.value, this.innerValue);
                    if (this.value == null) {
                        // para emitir quando limpar a seleção
                        this.$emit('onBlurFunction');
                        this.innerValue = null;
                    } else {
                        // para quando quiser apenas saber se houve mudança de valores
                        // caso o valor externo seja vazio ou os ids não baterem
                        if (
                            this.innerValue == null ||
                            (this.innerValue != null &&
                                this.getLabel(this.value) != this.getLabel(this.innerValue))
                        ) {
                            this.$emit('onBlurFunction');
                            this.innerValue = this.value;
                        }
                    }
                } else {
                    this.$emit('onBlurFunction');
                }
                // executa função mandada do componente pai
                if (this.onBlur) {
                    this.onBlurFunction();
                }
            },
        },
    },
    mounted() {
        this.focusedOut = !this.onBlur;
    },
    methods: {
        focus() {
            this.focusedOut = false;
        },
        inputFunction(data) {
            // Separado lógica para pegar o blur quando mudar a seleção

            this.$refs.select.focusedOut = true;

            // Envia os dados para o componente pai
            this.$emit('input', data);
            this.oldValue = this.innerValue;
            this.innerValue = data;

            this.blur();
        },
        blur() {
            this.focusedOut = true;

            if (this.onBlur) {
                this.onBlurFunction();
            }

            if (!this.multiple) {
                // para quando quiser apenas saber se houve uma mudança de valores
                // caso o valor externo ou interno estiver vazio
                // console.log('blur', this.title, this.value, this.innerValue);
                if (
                    (this.value == null && this.innerValue != null) ||
                    (this.value != null && this.innerValue == null)
                ) {
                    this.$emit('onBlurFunction');
                }
                // caso não esteja vazio e os ids não baterem
                if (this.value != null && this.innerValue != null) {
                    if (this.getLabel(this.value) != this.getLabel(this.innerValue)) {
                        this.$emit('onBlurFunction');
                    }
                }
            }
        },
        getLabel(o) {
            if (typeof o === 'string' || o == null) {
                return o;
            } else if (typeof o === 'object') {
                if (o[this.label] != undefined) {
                    if (o[this.mlLabelsField] && !this.mlLabels) {
                        return this.$t(o[this.label]);
                    }
                    return o[this.label];
                } else {
                    console.warn(
                        `[VERIFIED SELECT] A propriedade [${this.label}] não existe no objeto de opção!`
                    );
                    return '';
                }
            }
        },
    },
};
</script>

<style lang="scss">
.invalid {
    border-color: $red !important;
}

.single-select.ss-disabled {
    opacity: 1 !important;
    background: rgba(208, 207, 207, 0.6) !important;
}

span.validation {
    font-size: 8px;
    color: $red;
    display: block;
    font-weight: 600;
}

span.option-label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.color-block-selected {
    display: inline-block;
    cursor: pointer;
    width: 30px;
    height: 30px;
    border-radius: 4px;
    position: absolute;
    right: 30px;
}
.color-block-list {
    display: inline-block;
    cursor: pointer;
    width: 30px;
    height: 30px;
    border-radius: 4px;
    position: absolute;
    right: 2px;
}

.clearfix {
    height: 12px;
}
.div-imagem {
    height: 42px;
    position: relative;

    img {
        height: 100%;
        width: auto;
    }

    svg {
        height: auto;
        max-height: 100%;
    }
}
</style>
